import { useTranslation } from "@sagot/i18n";
import { Button, Dialog, DialogContent } from "@sagot/ui";

const V = "engage.workflows.versions";

interface RollbackDialogProps {
  number: number;
  /** Why the draft would be lost: saved changes the server knows about, edits still unsaved in the builder, or both. */
  unsaved: boolean;
  busy: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/** Rolling back replaces the draft. When the draft has changes the author must say so (the server asks again with `force`). */
export function RollbackDialog({ number, unsaved, busy, onConfirm, onClose }: RollbackDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog open onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent
        title={t(`${V}.forceTitle`, { number })}
        description={t(unsaved ? `${V}.forceBodyUnsaved` : `${V}.forceBody`, { number })}
        closeLabel={t("common.close")}
        footer={
          <>
            <Button variant="secondary" onClick={onClose}>{t("common.cancel")}</Button>
            <Button variant="danger" loading={busy} onClick={onConfirm}>{t(`${V}.forceConfirm`)}</Button>
          </>
        }
      />
    </Dialog>
  );
}
